import React from 'react';
import { Route } from 'react-router-dom';

import AlertasFicha from '../../MaisOpcoes/Alertas/AlertasFicha';
import MaisOpcoesAlertas from '../../MaisOpcoes/Alertas/AlertasIndex';
import DocumentosFicha from '../../MaisOpcoes/DocumentosSisAF/DocumentosFicha';
import MaisOpcoesDocumentos from '../../MaisOpcoes/DocumentosSisAF/DocumentosIndex';
import MaisOpcoesAjuda from '../../MaisOpcoes/MaisOpcoesAjuda';
import NotasVersaoFicha from '../../MaisOpcoes/NotasVersao/NotasVersaoFicha';
import MaisOpcoesNotasVersao from '../../MaisOpcoes/NotasVersao/NotasVersaoIndex';
import TasksFicha from '../../MaisOpcoes/Tasks/TasksFicha';
import MaisOpcoesTasks from '../../MaisOpcoes/Tasks/TasksIndex';
import TicketFicha from '../../MaisOpcoes/Tickets/TicketFicha';
import MaisOpcoesTickets from '../../MaisOpcoes/Tickets/TicketIndex';

const MaisOpcoesRoutes = () => {
  return (
    <>
      {/* Ajuda */}
      <Route path="maisopcoes/ajuda" element={<MaisOpcoesAjuda />} />

      {/* Alertas */}
      <Route path="maisopcoes/alertas" element={<MaisOpcoesAlertas />} />
      <Route
        path="maisopcoes/alertas/ficha/dadosgerais"
        element={<AlertasFicha />}
      />
      <Route
        path="maisopcoes/alertas/ficha/:id/dadosgerais"
        element={<AlertasFicha />}
      />

      {/* Documentos */}
      <Route path="maisopcoes/documentos" element={<MaisOpcoesDocumentos />} />
      <Route
        path="maisopcoes/documentos/ficha/dadosgerais"
        element={<DocumentosFicha />}
      />
      <Route
        path="maisopcoes/documentos/ficha/:id/dadosgerais"
        element={<DocumentosFicha />}
      />

      {/* Tasks */}
      <Route path="maisopcoes/tasks" element={<MaisOpcoesTasks />} />
      <Route
        path="maisopcoes/tasks/ficha/dadosgerais"
        element={<TasksFicha />}
      />
      <Route
        path="maisopcoes/tasks/ficha/:id/dadosgerais"
        element={<TasksFicha />}
      />

      {/* Tickets */}
      <Route path="maisopcoes/tickets" element={<MaisOpcoesTickets />} />
      <Route
        path="maisopcoes/tickets/ficha/dadosgerais"
        element={<TicketFicha />}
      />
      <Route
        path="maisopcoes/tickets/ficha/:id/dadosgerais"
        element={<TicketFicha />}
      />

      {/* Notas de versão */}
      <Route path="maisopcoes/notas" element={<MaisOpcoesNotasVersao />} />
      <Route
        path="maisopcoes/notas/ficha/dadosgerais"
        element={<NotasVersaoFicha />}
      />
      <Route
        path="maisopcoes/notas/ficha/:id/dadosgerais"
        element={<NotasVersaoFicha />}
      />
    </>
  );
};

export default MaisOpcoesRoutes;
